import { gql } from 'graphql-request'
import {
  contentFragments,
  mapToContentCard,
} from 'app/queries/content/all-content-list'
import { defaultsQuery } from 'app/queries/globals/defaults'
import { ContentCardProps } from 'app/components/content/ContentCard'

export const getSeriesQuery = () => gql`
  ${contentFragments}
  query fetchSeries($collection: String!, $season: String, $content: String) {
    fetchSeries(collection: $collection, season: $season, content: $content) {
      collection {
        name
        slug
        isSeries
        series {
          name
          id
        }
      }
      docs {
        episodeNumber
        episodeName
        episodePart
        content {
          ...content
        }
      }
      next {
        id
        slug
      }
      previous {
        id
        slug
      }
      series
    }

    ${defaultsQuery}
  }
`

export type SeriesData = {
  collection: {
    name: string
    isSeries: boolean
    slug: string
    series: {
      name: string
      id: string
    }[]
  }
  docs: {
    episodeNumber: number
    episodePart: number
    content: ContentCardProps
    episodeName?: string
  }[]
  next: {
    id: string
    slug: string
  }
  previous: {
    id: string
    slug: string
  }
  series: string
}

export const mapToSeriesData = (data: any) => {
  const docs = data.fetchSeries.docs.map((doc: any) => {
    return {
      ...doc,
      content: mapToContentCard(doc.content, data.Defaults),
    }
  })

  return {
    ...data.fetchSeries,
    docs,
  } as SeriesData
}
